import { cn } from '../../lib/utils';
import { UserRole } from '../../types/user';

interface RoleBadgeProps {
  role: UserRole | string;
  className?: string;
}

export function RoleBadge({ role, className }: RoleBadgeProps) {
  const getRoleConfig = (role: UserRole | string) => {
    const roleStr = String(role || 'USER');

    switch (roleStr) {
      case 'ADMIN':
        return {
          label: 'Admin',
          className: 'bg-primary/10 text-primary border border-primary/30',
        };
      case 'INVESTOR':
        return {
          label: 'Investor',
          className: 'bg-secondary/15 text-secondary border border-secondary/30',
        };
      case 'ASSET_MANAGER':
        return {
          label: 'Asset Manager',
          className: 'bg-warning/10 text-warning border border-warning/30',
        };
      case 'COMPLIANCE_OFFICER':
        return {
          label: 'Compliance',
          className: 'bg-success/10 text-success border border-success/30',
        };
      case 'SUPPORT':
        return {
          label: 'Support',
          className: 'bg-info/10 text-info border border-info/30',
        };
      case 'USER':
      default:
        return {
          label: 'User',
          className: 'bg-muted/50 text-muted-foreground border border-muted-foreground/20',
        };
    }
  };

  const config = getRoleConfig(role);

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium',
        config.className,
        className
      )}
    >
      {config.label}
    </span>
  );
}
